// src/data/carsData.js
export const categories = [
  { id: "rent-car", label: "Rent Car" },
  { id: "ride", label: "Ride" },
];

export const products = {
  "rent-car": [
    {
      id: "sedan-rental",
      name: "Sedan Rental",
      image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg",
      rent: true,
      appointment: false,
      withoutQuantity: true,
      type:'rental',
      price:1000,
      companyId:'al companyy'
    },
    {
      id: "suv-rental",
      name: "SUV Rental",
      image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg",
      rent: true,
      appointment: false,
      withoutQuantity: true,
    },
  ],
  ride: [
    {
      id: "city-ride",
      name: "City Ride",
      image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg",
      rent: true,
      appointment: true,
      withoutQuantity: true, // no quantity for rides
    },
    {
      id: "airport-ride",
      name: "Airport Ride",
      image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg",
      rent: true,
      appointment: true,
      withoutQuantity: true,
    },
  ],
};